import { GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CustomDataGrid } from "../../../components/CustomDataGrid";
import { baseURL } from "../../../config/api";
import moment from "moment";
import { Tabs } from "../../../components/Tabs";
import { CustomDateField } from "../../../components/CustomDateField";
import { getStatusColor } from "../../../utils/functionHelper";
import { getLocation } from "../../../services/Location";
import useAuth from "../../../hook/useAuth";
import { getStatus } from "../../../services/Appointment";

const tabs = [
    {
        label: "All",
    },
    {
        label: "My WorkOrders",
    },
    {
        label: "Queued",
    },
    {
        label: "InProgress",
    },
    {
        label: "Done",
    }
]

export const WorkOrders = () => {
    const { auth }: any = useAuth();
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    const [searchTableData, setSearchTableData] = useState<any[]>([]);
    const [totalLength, setTotalLength] = useState<number>(0);
    const [loading, setLoading] = useState(true);
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const [date, setDate] = useState<string>(moment().format("YYYY-MM-DD"));
    const [locationId, setLocationId] = useState<number>(0);
    const [locationOptions, setLocationOptions] = useState<any[]>([]);
    const [status, setStatus] = useState<any[]>([]);
    const columns: GridColDef[] = [
        {
            field: "workOrderID",
            headerName: "#",
            flex: 1,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                return (
                    <Link to="/admin/workorders/update-workorder" state={{ id: params?.id, appointmentId: params?.row?.appointmentID }} className="underline text-[#0000ff]">
                        {params?.value}
                    </Link>
                );
            },
        },
        {
            field: "employeeName",
            headerName: "Employee Name",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "parkingInSpot",
            headerName: "Parking Check-In",
            editable: false,
            sortable: false,
            flex: 1,
        },
        {
            field: "parkingOutSpot",
            headerName: "Parking Check-Out",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "vehicleTag",
            headerName: "Vehicle Tag",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "statusName",
            headerName: "Status",
            type: "number",
            flex: 1,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                const color = getStatusColor(params.value);
                return (
                    <div className="flex items-end h-full">
                        <span className={`inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold ${color.colorBg} ${color.colorText}`}>
                            {params.value}
                        </span>
                    </div>
                );
            }
        },

    ];

    useEffect(() => {
        getLocation()
            .then((data) => {
                setLocationOptions(() => data?.map((loc: any) => {
                    return {
                        value: loc?.id,
                        label: loc?.locationName
                    }
                }))
            })
            .catch((error) => {
                console.error(error)
            })
    }, [])


    useEffect(() => {
        getStatus("WorkOrder")
            .then((data) => {
                setStatus(() => data?.map((status: any) => {
                    return {
                        id: status.statusID,
                        statusValue: status.statusValue
                    }
                }))
            })
            .catch((error) => {
                console.error(error)
            })
    }, [])

    useEffect(() => {
        emptySearchApiCall(paginationModel);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel, locationId, date, activeIndex])

    const emptySearchApiCall = (newPaginationModel: any) => {
        if (locationId > 0) {
            if (date && activeIndex === 0) {
                setLoading(true);
                const updatedDate = moment(date).endOf('day');
                let formatDateString = updatedDate.format('YYYY-MM-DD');
                fetch(`${baseURL}workOrders/GetWorkOrdersReportPaging?page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}&locationId=${locationId}&appointmentdate=${formatDateString}`)
                    .then((res) => res.json())
                    .then((data) => {
                        const result = data?.workOrders?.map((item: any) => {
                            return {
                                ...item,
                                id: item?.workOrderID,
                                parkedInAt: moment(new Date(item?.parkedInAt)).format("MM/DD/YYYY hh:mm A"),
                                parkedOutAt: moment(new Date(item?.parkedOutAt)).format("MM/DD/YYYY hh:mm A"),
                            };
                        })

                        setSearchTableData(result);
                        setTotalLength(data?.count);
                        setLoading(false);
                    })
                    .catch(error => {
                        setSearchTableData([]);
                        setTotalLength(0);
                        setLoading(false);
                        console.error(error);
                    });
            }
            else if (date && activeIndex === 1) {
                setLoading(true);
                const updatedDate = moment(date).endOf('day');
                let formatDateString = updatedDate.format('YYYY-MM-DD');
                fetch(`${baseURL}workOrders/GetWorkOrdersReportPaging?page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}&employeeId=${auth?.id}&locationId=${locationId}&appointmentdate=${formatDateString}`)
                    .then((res) => res.json())
                    .then((data) => {
                        const result = data?.workOrders?.map((item: any) => {
                            return {
                                ...item,
                                id: item?.workOrderID,
                                parkedInAt: moment(new Date(item?.parkedInAt)).format("MM/DD/YYYY hh:mm A"),
                                parkedOutAt: moment(new Date(item?.parkedOutAt)).format("MM/DD/YYYY hh:mm A"),
                            };
                        })

                        setSearchTableData(result);
                        setTotalLength(data?.count);
                        setLoading(false);
                    })
                    .catch(error => {
                        setSearchTableData([]);
                        setTotalLength(0);
                        setLoading(false);
                        console.error(error);
                    });
            }
            else if (date && activeIndex === 2) {
                setLoading(true);
                const updatedDate = moment(date).endOf('day');
                let formatDateString = updatedDate.format('YYYY-MM-DD');
                const statusId = status?.filter((item: any) => item?.statusValue === "Queued")[0]?.id;
                fetch(`${baseURL}workOrders/GetWorkOrdersReportPaging?page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}&locationId=${locationId}&StatusId=${statusId}&appointmentdate=${formatDateString}`)
                    .then((res) => res.json())
                    .then((data) => {
                        const result = data?.workOrders?.map((item: any) => {
                            return {
                                ...item,
                                id: item?.workOrderID,
                                parkedInAt: moment(new Date(item?.parkedInAt)).format("MM/DD/YYYY hh:mm A"),
                                parkedOutAt: moment(new Date(item?.parkedOutAt)).format("MM/DD/YYYY hh:mm A"),
                            };
                        })

                        setSearchTableData(result);
                        setTotalLength(data?.count);
                        setLoading(false);
                    })
                    .catch(error => {
                        setSearchTableData([]);
                        setTotalLength(0);
                        setLoading(false);
                        console.error(error);
                    });
            }
            else if (date && activeIndex === 3) {
                setLoading(true);
                const updatedDate = moment(date).endOf('day');
                let formatDateString = updatedDate.format('YYYY-MM-DD');
                const statusId = status?.filter((item: any) => item?.statusValue === "InProgress")[0]?.id;
                fetch(`${baseURL}workOrders/GetWorkOrdersReportPaging?page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}&locationId=${locationId}&StatusId=${statusId}&appointmentdate=${formatDateString}`)
                    .then((res) => res.json())
                    .then((data) => {
                        const result = data?.workOrders?.map((item: any) => {
                            return {
                                ...item,
                                id: item?.workOrderID,
                                parkedInAt: moment(new Date(item?.parkedInAt)).format("MM/DD/YYYY hh:mm A"),
                                parkedOutAt: moment(new Date(item?.parkedOutAt)).format("MM/DD/YYYY hh:mm A"),
                            };
                        })

                        setSearchTableData(result);
                        setTotalLength(data?.count);
                        setLoading(false);
                    })
                    .catch(error => {
                        setSearchTableData([]);
                        setTotalLength(0);
                        setLoading(false);
                        console.error(error);
                    });
            }
            else if (date && activeIndex === 4) {
                setLoading(true);
                const updatedDate = moment(date).endOf('day');
                let formatDateString = updatedDate.format('YYYY-MM-DD');
                const statusId = status?.filter((item: any) => item?.statusValue === "Done")[0]?.id;
                fetch(`${baseURL}workOrders/GetWorkOrdersReportPaging?page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}&locationId=${locationId}&StatusId=${statusId}&appointmentdate=${formatDateString}`)
                    .then((res) => res.json())
                    .then((data) => {
                        const result = data?.workOrders?.map((item: any) => {
                            return {
                                ...item,
                                id: item?.workOrderID,
                                parkedInAt: moment(new Date(item?.parkedInAt)).format("MM/DD/YYYY hh:mm A"),
                                parkedOutAt: moment(new Date(item?.parkedOutAt)).format("MM/DD/YYYY hh:mm A"),
                            };
                        })

                        setSearchTableData(result);
                        setTotalLength(data?.count);
                        setLoading(false);
                    })
                    .catch(error => {
                        setSearchTableData([]);
                        setTotalLength(0);
                        setLoading(false);
                        console.error(error);
                    });
            }
        }
        else {
            if (date && activeIndex === 0) {
                setLoading(true);
                const updatedDate = moment(date).endOf('day');
                let formatDateString = updatedDate.format('YYYY-MM-DD');
                fetch(`${baseURL}workOrders/GetWorkOrdersReportPaging?page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}&appointmentdate=${formatDateString}`)
                    .then((res) => res.json())
                    .then((data) => {
                        const result = data?.workOrders?.map((item: any) => {
                            return {
                                ...item,
                                id: item?.workOrderID,
                                parkedInAt: moment(new Date(item?.parkedInAt)).format("MM/DD/YYYY hh:mm A"),
                                parkedOutAt: moment(new Date(item?.parkedOutAt)).format("MM/DD/YYYY hh:mm A"),
                            };
                        })

                        setSearchTableData(result);
                        setTotalLength(data?.count);
                        setLoading(false);
                    })
                    .catch(error => {
                        setSearchTableData([]);
                        setTotalLength(0);
                        setLoading(false);
                        console.error(error);
                    });
            }
            else if (date && activeIndex === 1) {
                setLoading(true);
                const updatedDate = moment(date).endOf('day');
                let formatDateString = updatedDate.format('YYYY-MM-DD');
                fetch(`${baseURL}workOrders/GetWorkOrdersReportPaging?page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}&employeeId=${auth?.id}&appointmentdate=${formatDateString}`)
                    .then((res) => res.json())
                    .then((data) => {
                        const result = data?.workOrders?.map((item: any) => {
                            return {
                                ...item,
                                id: item?.workOrderID,
                                parkedInAt: moment(new Date(item?.parkedInAt)).format("MM/DD/YYYY hh:mm A"),
                                parkedOutAt: moment(new Date(item?.parkedOutAt)).format("MM/DD/YYYY hh:mm A"),
                            };
                        })

                        setSearchTableData(result);
                        setTotalLength(data?.count);
                        setLoading(false);
                    })
                    .catch(error => {
                        setSearchTableData([]);
                        setTotalLength(0);
                        setLoading(false);
                        console.error(error);
                    });
            }
            else if (date && activeIndex === 2) {
                setLoading(true);
                const updatedDate = moment(date).endOf('day');
                let formatDateString = updatedDate.format('YYYY-MM-DD');
                const statusId = status?.filter((item: any) => item?.statusValue === "Queued")[0]?.id;
                fetch(`${baseURL}workOrders/GetWorkOrdersReportPaging?page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}&StatusId=${statusId}&appointmentdate=${formatDateString}`)
                    .then((res) => res.json())
                    .then((data) => {
                        const result = data?.workOrders?.map((item: any) => {
                            return {
                                ...item,
                                id: item?.workOrderID,
                                parkedInAt: moment(new Date(item?.parkedInAt)).format("MM/DD/YYYY hh:mm A"),
                                parkedOutAt: moment(new Date(item?.parkedOutAt)).format("MM/DD/YYYY hh:mm A"),
                            };
                        })

                        setSearchTableData(result);
                        setTotalLength(data?.count);
                        setLoading(false);
                    })
                    .catch(error => {
                        setSearchTableData([]);
                        setTotalLength(0);
                        setLoading(false);
                        console.error(error);
                    });
            }
            else if (date && activeIndex === 3) {
                setLoading(true);
                const updatedDate = moment(date).endOf('day');
                let formatDateString = updatedDate.format('YYYY-MM-DD');
                const statusId = status?.filter((item: any) => item?.statusValue === "InProgress")[0]?.id;
                fetch(`${baseURL}workOrders/GetWorkOrdersReportPaging?page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}&StatusId=${statusId}&appointmentdate=${formatDateString}`)
                    .then((res) => res.json())
                    .then((data) => {
                        const result = data?.workOrders?.map((item: any) => {
                            return {
                                ...item,
                                id: item?.workOrderID,
                                parkedInAt: moment(new Date(item?.parkedInAt)).format("MM/DD/YYYY hh:mm A"),
                                parkedOutAt: moment(new Date(item?.parkedOutAt)).format("MM/DD/YYYY hh:mm A"),
                            };
                        })

                        setSearchTableData(result);
                        setTotalLength(data?.count);
                        setLoading(false);
                    })
                    .catch(error => {
                        setSearchTableData([]);
                        setTotalLength(0);
                        setLoading(false);
                        console.error(error);
                    });
            }
            else if (date && activeIndex === 4) {
                setLoading(true);
                const updatedDate = moment(date).endOf('day');
                let formatDateString = updatedDate.format('YYYY-MM-DD');
                const statusId = status?.filter((item: any) => item?.statusValue === "Done")[0]?.id;
                fetch(`${baseURL}workOrders/GetWorkOrdersReportPaging?page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}&StatusId=${statusId}&appointmentdate=${formatDateString}`)
                    .then((res) => res.json())
                    .then((data) => {
                        const result = data?.workOrders?.map((item: any) => {
                            return {
                                ...item,
                                id: item?.workOrderID,
                                parkedInAt: moment(new Date(item?.parkedInAt)).format("MM/DD/YYYY hh:mm A"),
                                parkedOutAt: moment(new Date(item?.parkedOutAt)).format("MM/DD/YYYY hh:mm A"),
                            };
                        })

                        setSearchTableData(result);
                        setTotalLength(data?.count);
                        setLoading(false);
                    })
                    .catch(error => {
                        setSearchTableData([]);
                        setTotalLength(0);
                        setLoading(false);
                        console.error(error);
                    });
            }
        }

    }

    const hanbleTabChange = (index: number, tab: any) => {
        setActiveIndex(tab?.id || index);
        setCurrentIndex(index);
        setPaginationModel({
            page: 0,
            pageSize: 10,
        })
    }

    return (
        <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
            <div className="w-full h-full bg-white p-4 rounded-md">
                <div className="flex items-center justify-between py-2">
                    <div className="w-full mt-4">
                        <Tabs tabs={tabs} onChange={(index, tab) => hanbleTabChange(index, tab)} activeIndex={currentIndex} />
                    </div>
                    <div className="flex items-center gap-1.5">
                        <div>
                            <select
                                value={locationId}
                                onChange={(e) => setLocationId(Number(e.target.value))}
                                className="w-[200px] border border-gray-300 rounded-md p-3 text-sm outline-none focus:border-primary bg-white"
                            >
                                <option value={0}>
                                    All
                                </option>
                                {locationOptions.map((loc: any, index: number) => (
                                    <option key={index} value={loc?.value}>
                                        {loc?.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="flex items-center gap-1.5">
                            <button className={`px-[4px] py-[6px] rounded-lg border flex items-center justify-center`}>
                                <span className="material-symbols-outlined text-[25px] font-light"
                                    onClick={() =>
                                        setDate(() => {
                                            const d = new Date(date);
                                            d.setDate(d.getDate() - 1);
                                            return d.toISOString().split("T")[0];
                                        })
                                    }>
                                    chevron_left
                                </span>
                            </button>


                            <CustomDateField
                                value={date}
                                onChange={(value) => { setDate(value) }}
                                className="w-[110px] border border-gray-300 rounded-xl px-[5px] py-[10px] text-sm outline-none focus:border-primary"
                                required={true}
                                showValidMessage={false}
                                isModified={true}
                            />

                            <button className={`px-[4px] py-[6px] rounded-lg border flex items-center justify-center`}>
                                <span className="material-symbols-outlined text-[25px] font-light"
                                    onClick={() =>
                                        setDate(() => {
                                            const d = new Date(date);
                                            d.setDate(d.getDate() + 1);
                                            return d.toISOString().split("T")[0];
                                        })
                                    }
                                >
                                    chevron_right
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className={`w-full border border-[#E4E7EC] rounded-[16px]`}>
                    <div className={`flex justify-between items-center p-4 border-b border-[#E4E7EC]`}>
                        <div className="flex items-center gap-1.5">

                            <h2 className={`text-lg font-semibold text-[#1D2939]`}>Work Orders</h2>
                        </div>
                        <div className="flex items-center gap-1.5">
                        </div>
                    </div>

                    <CustomDataGrid
                        filteredRows={searchTableData}
                        columns={columns?.map(col => ({
                            ...col,
                            headerClassName: "bg-[#F9FAFB]",
                        }))}
                        loading={loading}
                        totalLength={totalLength}
                        paginationModel={paginationModel}
                        setPaginationModel={setPaginationModel}
                    />
                </div>
            </div>

        </div>
    )
}